import cogoToast from 'cogo-toast';
import moment from 'moment';
import _ from 'lodash';
import slugify from 'slugify';
import * as htmlToImage from 'html-to-image';

export const getRootSMSUrl = () => {
  if (!isDevelopment()) return `https://${isProduction() ? '' : 'staging.'}shopmy.us`;
  return process.env.REACT_APP_WEB_URL || getPortlessReactUrl() || process.env.REACT_APP_URL || 'http://localhost:3000';
};

// export const copyToClipboard = (str, logSuccess, logTime = 1) => {
//   const el = document.createElement('textarea'); // Create a <textarea> element
//   el.value = str; // Set its value to the string that you want copied
//   el.setAttribute('readonly', ''); // Make it readonly to be tamper-proof
//   el.style.position = 'absolute';
//   el.style.left = '-9999px'; // Move outside the screen to make it invisible
//   document.body.appendChild(el); // Append the <textarea> element to the HTML document
//   const selected =
//     document.getSelection().rangeCount > 0 // Check if there is any content selected previously
//       ? document.getSelection().getRangeAt(0) // Store selection if found
//       : false; // Mark as false to know no selection existed before
//   el.select(); // Select the <textarea> content
//   document.execCommand('copy'); // Copy - only works as a result of a user action (e.g. click events)
//   document.body.removeChild(el); // Remove the <textarea> element
//   if (selected) {
//     // If a selection existed before copying
//     document.getSelection().removeAllRanges(); // Unselect everything on the HTML document
//     document.getSelection().addRange(selected); // Restore the original selection
//   }
//   logSuccess && cogoToast.success(typeof logSuccess === 'string' ? logSuccess : 'Copied to clipboard', { hideAfter: logTime });
// };

/**
 *
 * @param {string} str - string to copy to clipboard
 * @param {boolean} logSuccess - whether to log success
 * @param {number} logTime - how long the success message should be displayed (default 1 second)
 */
export const copyToClipboard = async (str, logSuccess, logTime = 1) => {
  await navigator.clipboard.writeText(str);
  logSuccess && cogoToast.success(typeof logSuccess === 'string' ? logSuccess : 'Copied to clipboard', { hideAfter: logTime });
};

export const isProduction = () => window.location.href.includes('shopmyshelf.us');
export const isDevelopment = () => window.location.hostname === 'localhost' || window.location.hostname.endsWith('.localhost');

const getPortlessReactUrl = () => {
  const hostnameParts = window.location.hostname.split('.');
  const adminIndex = hostnameParts.lastIndexOf('admin');
  if (adminIndex === -1) return null;
  hostnameParts[adminIndex] = 'react';
  return `${window.location.protocol}//${hostnameParts.join('.')}`;
};

export const getPrettyPriceDisplay = priceRaw => {
  if (!priceRaw) return '';
  const price = parseFloat(priceRaw);
  return `$${price.toFixed(price === Math.floor(price) ? 0 : 2)}`;
};
export const getServerFormattedDate = () => moment().format('YYYY-MM-DD HH:mm:ss');

export const getSmartImage = img => {
  if (!img) {
    return null;
  }

  let newImage = img;

  // Parse object if it exists
  newImage = typeof newImage === 'object' ? _.first(newImage) : newImage;

  // Add https in case it doesn't exist (local dev servers are http-only, leave them alone)
  if (!newImage.startsWith('http://localhost')) newImage = newImage.split('http://').join('https://');

  // Add Custom handling for Target
  if (img.includes('target.scene7') || img.includes('images.bloomingdaleassetts') || img.includes('r29static')) {
    newImage = `${newImage}${newImage.includes('?') ? '&' : '?'}&fmt=pjpeg`;
  }

  // Add custom handling for Abercrombie/Hollister (Scene7 serves multi-MB originals without a width)
  if ((img.includes('img.abercrombie.com') || img.includes('img.hollisterco.com')) && !newImage.includes('wid=')) {
    newImage = `${newImage}${newImage.includes('?') ? '&' : '?'}wid=600`;
  }

  newImage = getCloudFrontUrlFromS3Url(newImage);
  return newImage;
};

export const getCloudFrontUrlFromS3Url = s3_url => {
  // Convert S3 URL to CloudFront URL so we can access the bucket
  if (!s3_url) return s3_url;

  let imageUrl = s3_url;

  // Handle cloudfront optimization
  imageUrl = imageUrl.replace('production-shopmyshelf-uploads.s3-us-east-2.amazonaws.com', 'static.shopmy.us/uploads');
  imageUrl = imageUrl.replace('production-shopmyshelf-uploads.s3.us-east-2.amazonaws.com', 'static.shopmy.us/uploads');
  imageUrl = imageUrl.replace('production-shopmyshelf-uploads.s3.amazonaws.com', 'static.shopmy.us/uploads');
  imageUrl = imageUrl.replace('staging-shopmyshelf-uploads.s3-us-east-2.amazonaws.com', 'static.shopmy.us/staging/uploads');
  imageUrl = imageUrl.replace('staging-shopmyshelf-uploads.s3.us-east-2.amazonaws.com', 'static.shopmy.us/staging/uploads');
  imageUrl = imageUrl.replace('staging-shopmyshelf-uploads.s3.amazonaws.com', 'static.shopmy.us/staging/uploads');
  imageUrl = imageUrl.replace('askemma-static-public.s3.us-east-2.amazonaws.com', 'static.shopmy.us');

  // pins
  imageUrl = imageUrl.replace('production-shopmyshelf-pins.s3.amazonaws.com', 'static.shopmy.us/pins');
  imageUrl = imageUrl.replace('production-shopmyshelf-pins.s3.us-east-2.amazonaws.com', 'static.shopmy.us/pins');
  imageUrl = imageUrl.replace('staging-shopmyshelf-pins.s3.amazonaws.com', 'static.shopmy.us/staging/pins');
  imageUrl = imageUrl.replace('staging-shopmyshelf-pins.s3.us-east-2.amazonaws.com', 'static.shopmy.us/staging/pins');

  return imageUrl;
};

// Canonical shareable URLs, mirroring getCreatorProfileUrl / getCollectionUrlFromId in the react app helpers.
export const getCreatorProfileUrl = username => `https://shopmy.us/shop/${username}`;
export const getCollectionUrlFromId = Collection_id => `https://shopmy.us/collections/${Collection_id}`;
export const getShopProductUrl = Product_id => `${getRootSMSUrl()}/shop/product/${Product_id}`;

export const parseJson = val => {
  if (!val || typeof val !== 'string') return val || null;
  try {
    return JSON.parse(val);
  } catch {
    return null;
  }
};

export const getUrlParam = param => new URLSearchParams(window.location.search).get(param);

export const setUrlParam = (param, value) => {
  const currentUrl = new URL(window.location.href);
  currentUrl.searchParams.set(param, value);
  window.history.replaceState({}, document.title, currentUrl.toString());
};

export const deleteUrlParam = param => {
  const currentUrl = new URL(window.location.href);
  currentUrl.searchParams.delete(param);
  window.history.replaceState({}, document.title, currentUrl.toString());
};

export const downloadToCsv = async (rows, name = 'Download') => {
  /*
    data = [{
      'Header 1': 'Value 1' 
    },{
      'Header 1': 'Value 2' 
    }]
  */
  let headers = _.keys(rows[0]);
  const cleanValue = val =>
    typeof val !== 'string'
      ? val
      : val
          ?.split(',')
          ?.join('-')
          ?.split('#')
          ?.join('Number');
  let csvContent =
    'data:text/csv;charset=utf-8,' +
    `${headers.map(cleanValue).join(',')}\n` +
    rows
      .map(d =>
        _.values(d)
          .map(cleanValue)
          .join(',')
      )
      .join('\n');
  const encodedUri = encodeURI(csvContent);
  var downloadLink = document.createElement('a');
  downloadLink.href = encodedUri;
  downloadLink.download = `${name}.csv`;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};

export const saveImageAs = (dataUrl, name) => {
  const image_element = document.createElement('a');
  image_element.href = dataUrl;
  image_element.download = name;
  document.body.appendChild(image_element);
  image_element.click();
  document.body.removeChild(image_element);
};

export const downloadImageUsingElementId = async (elementId, config = {}) => {
  const downloadName = `${slugify(elementId.split('_')[0])}.png`;
  const node = document.getElementById(elementId);

  return htmlToImage.toPng(node, { cacheBust: true, ...config }).then(data_url => {
    saveImageAs(data_url, downloadName);
  });
};

export const wait = (timeToWait = 500) => new Promise(r => setTimeout(r, timeToWait));

export const matchScrollHeight = (element, extraHeight = 0) => {
  /*
    Use this to lock a textarea to the height of it's inner contents, for example:
      <textarea rows={4} ref={e => matchScrollHeight(e)} />

    Use the extraHeight param to account for extra height not included in scrollHeight, such as borders, margins, scrollbars, etc.
  */
  element && (element.style.height = `inherit`);
  element && (element.style.height = `${element.scrollHeight + extraHeight}px`);
};

export const randomizeArray = array => {
  const newArr = [...array];
  for (let i = 0; i < newArr.length; i++) {
    const j = Math.floor(Math.random() * (i + 1));
    [newArr[i], newArr[j]] = [newArr[j], newArr[i]];
  }

  // return copy so react can map over it
  return newArr;
};
